import { diffLines } from "diff";
import { useMemo } from "react";

import styles from "./styles.module.css";

type TemplateDeploymentYamlDiffPanelProps = {
  original: string;
  modified: string;
};

const TemplateDeploymentYamlDiffPanel = ({
  original,
  modified,
}: TemplateDeploymentYamlDiffPanelProps) => {
  const lines = useMemo(() => {
    const changes = diffLines(original, modified);
    return changes.flatMap((change) =>
      change.value
        .replace(/\n$/, "")
        .split("\n")
        .map((content) => ({ content, added: change.added, removed: change.removed }))
    );
  }, [original, modified]);

  return (
    <div className={styles.diffViewer}>
      {lines.map((line, index) => (
        <div
          key={`${index}-${line.content}`}
          className={`${styles.line} ${line.added ? styles.lineAdded : ""} ${line.removed ? styles.lineRemoved : ""}`}
        >
          <span className={styles.lineGutter}>
            {line.added && "+"}
            {line.removed && "-"}
            {!line.added && !line.removed && " "}
          </span>
          <pre className={styles.lineContent}>{line.content}</pre>
        </div>
      ))}
    </div>
  );
};

export default TemplateDeploymentYamlDiffPanel;
